// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // urlServices: 'http://172.19.0.204:9085/reconocimientos-webservice/'
  // urlServices: 'http://dllo.udea.edu.co:9085/reconocimientos-webservice/'
  urlServices:  window.location.origin + '/mares-reconocimientos-back/'
  //urlServices: 'http://localhost:8080/mares-reconocimientos-back/'
  // urlServices: 'http://test.udea.edu.co:29000/reconocimientos-webservice/'
  // urlServices: 'http://172.19.0.203:29000/reconocimientos-webservice/'
  // urlServices: 'https://asone.udea.edu.co/mares-reconocimientos-back/'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zon e-error';  // Included with Angular CLI.
